var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",staticStyle:{"background-color":"#FFF","display":"flex","justify-content":"center","align-items":"center"}},[_c('qrcode-stream',{staticStyle:{"width":"450px","height":"100%"},on:{"decode":_vm.onDecode,"detect":_vm.onDetect}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-289a1644","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Passes/Scan.vue
// module id = null
// module chunks = 